// Raccourcis clavier affichés selon le système de l'utilisateur. Seules ces touches changent entre Mac et Windows
// (Linux et les autres comme Windows) : Mod (⌘ Cmd sur Mac, Ctrl ailleurs ; Editor accepte les deux partout), Alt
// (⌥ Option) et Effacer (Suppr ou Retour arrière ; un portable Mac n'a que ⌫). Maj, Entrée, Échap… ne changent pas.

export const isMac = (nav = typeof navigator === 'undefined' ? undefined : navigator) =>
  /mac|iphone|ipad|ipod/i.test(nav?.userAgentData?.platform || nav?.platform || '');

export const platformOf = (mac = isMac()) => (mac ? 'mac' : 'windows');

const MAC_SYMBOLS = { Ctrl: '⌃', Alt: '⌥', Maj: '⇧', Mod: '⌘' };
const PC_NAMES = { Mod: 'Ctrl' };

// Libellé compact d'une infobulle, accord « Mod+Maj+Z » : « ⇧⌘Z » sur Mac (symboles dans l'ordre d'Apple),
// « Ctrl+Maj+Z » ailleurs.
export const shortcutLabel = (chord, mac = isMac()) => {
  const keys = chord.split('+');
  const key = keys.pop();
  if (mac) return Object.keys(MAC_SYMBOLS).filter((m) => keys.includes(m)).map((m) => MAC_SYMBOLS[m]).join('') + key;
  return [...keys.map((m) => PC_NAMES[m] || m), key].join('+');
};

// Touches de l'aide : <kbd>Mod</kbd>, <kbd>Alt</kbd>, <kbd>Effacer</kbd> ; toute autre touche s'affiche telle quelle.
const KEY_NAMES = {
  mac: { Mod: ['⌘ Cmd'], Alt: ['⌥ Option'], Ctrl: ['⌃ Ctrl'], Effacer: ['⌫'] },
  windows: { Mod: ['Ctrl'], Effacer: ['Suppr', 'Retour arrière'] },
};
export const keyNames = (key, mac = isMac()) => KEY_NAMES[platformOf(mac)][key] || [key];

const escape = (text) => text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

// <kbd>…</kbd> d'un fragment HTML, touches du système (Effacer : « Suppr ou Retour arrière » en deux touches).
export const keysHtml = (html, mac = isMac()) =>
  html.replace(/<kbd>([^<]+)<\/kbd>/g, (_, key) =>
    keyNames(key, mac).map((name) => `<kbd>${escape(name)}</kbd>`).join(' ou ')
  );

// Même chose en texte brut (texte alternatif, pastilles).
export const keysText = (text, mac = isMac()) =>
  text?.replace(/<kbd>([^<]+)<\/kbd>/g, (_, key) => keyNames(key, mac).join(' ou '));
